/**
 * Taalkiezer — wisselt de actieve UI-taal (en bewaart die in localStorage via
 * de language-detector). Herbruikbaar: login-scherm, instellingen, top-bar.
 */
import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../../../i18n/index.js';

export function LanguageSwitcher({ className = '' }: { className?: string }) {
  const { i18n, t } = useTranslation();
  const current = i18n.resolvedLanguage ?? i18n.language;

  return (
    <label className={`inline-flex items-center gap-1.5 text-sm text-gray-500 ${className}`}>
      <Globe className="h-4 w-4" />
      <span className="sr-only">{t('common.language')}</span>
      <select
        value={current}
        onChange={e => i18n.changeLanguage(e.target.value)}
        className="bg-transparent border-none focus:outline-none cursor-pointer text-gray-600 hover:text-gray-900"
        aria-label={t('common.language')}
      >
        {SUPPORTED_LANGUAGES.map(l => (
          <option key={l.code} value={l.code}>{l.label}</option>
        ))}
      </select>
    </label>
  );
}
